import React from 'react';
import { SectionTitle } from '@/components/ui/shared/section-title';
import { ExternalLink } from 'lucide-react';

interface Specification {
  value: string | number | { id: number; title: string; updatedAt?: string; createdAt?: string } | null;
  light?: boolean;
  url?: string;
}

interface Specs {
  label: string;
  specifications: Specification[];
}

interface ArtworkSpecificationsProps {
  /** Left out, the list is drawn without a heading of its own. */
  title?: string;
  specs: Specs[];
  sectionClassName?: string;
}

export function LandscapeSpecifications({ title, specs, sectionClassName }: ArtworkSpecificationsProps) {
  return (
    <div>
      {title ? <SectionTitle title={title} className={sectionClassName} /> : null}

      <div className="space-y-3 border border-gray-100 p-3 rounded-md uppercase">
        {specs.map((spec, index) => (
          <div key={index} className="text-[10px] flex items-start lg:items-center flex-col lg:flex-row  gap-1 lg:gap-3 mb-4 last:mb-0">
            <div className="text-gray-800 inline lg:block">{spec.label}:</div>
            <div className="flex flex-wrap gap-3">
              {spec.specifications.map((specification, index2) => {
                const commonClassName = `${/CONTRACT|INSCRIPTION ADDRESS/.test(spec.label.toUpperCase()) ? 'normal-case break-all' : ''} px-1 py-[1px] rounded-sm transition-colors border text-gray-900 ${
                  specification.light
                    ? 'bg-white hover:bg-gray-100 border-gray-200'
                    : 'bg-gray-200 hover:bg-gray-300 border-transparent'
                }`;

                return specification?.url ? (
                  <a
                    key={index2}
                    href={specification.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${commonClassName} cursor-pointer inline-flex`}
                  >
                    {specification?.value && typeof specification?.value === 'object' ? specification.value.title : String(specification?.value ?? '')}
                    <ExternalLink className="h-3 w-3 ml-1" />
                  </a>
                ) : (
                  <span key={index2} className={commonClassName}>
                    {specification?.value && typeof specification?.value === 'object' ? specification.value.title : String(specification?.value ?? '')}
                  </span>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// flex items-center space-x-1 text-[8px] uppercase px-2.5 py-1 bg-transparent border border-zinc-200 rounded-md hover:border-zinc-800 transition-all duration-300 group
